// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"130c4154a16805906c12","655":"53d68e219ec08466ce59"}[chunkId] + ".js";
};